import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as InvalidIcon } from 'assets/img/icons/invalid-icon.svg';
import { getIn } from 'formik';
import {
  Label,
  Input,
  InputWrapper,
  Container,
  ErrorMessageWrapper,
  Icon
} from './styled';

const TextInput = ({
  type,
  label,
  name,
  placeholder,
  iconSrc,
  formik,
  hideInput = false,
  value,
  onChange,
  validationErrorMessage,
  variant = 'fountainBlue',
  ...props
}) => {
  const errorMessage =
    validationErrorMessage ||
    (getIn(formik?.touched, name) && getIn(formik?.errors, name));

  return (
    <Container>
      <InputWrapper>
        <Input
          variant={variant}
          value={value}
          readOnly={!name && !formik}
          onChange={(e) => {
            if (onChange) {
              onChange(e.target.value);
            }
          }}
          type={type || (hideInput ? 'password' : 'text')}
          isFieldValid={!errorMessage}
          placeholder={placeholder}
          {...props}
          {...formik?.getFieldProps(name)}
        />
        {Boolean(iconSrc) && <Icon src={iconSrc} alt="icon" />}
        <Label isFieldValid={!errorMessage}>{label}</Label>
      </InputWrapper>
      {Boolean(errorMessage) && (
        <ErrorMessageWrapper>
          <InvalidIcon />
          {errorMessage}
        </ErrorMessageWrapper>
      )}
    </Container>
  );
};

TextInput.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  iconSrc: PropTypes.string,
  formik: PropTypes.object,
  hideInput: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  variant: PropTypes.oneOf(['gray', 'fountainBlue', 'white']),
  validationErrorMessage: PropTypes.string
};

export default TextInput;
